export interface ProductCostBreakdown {
  productId: string;
  type: string;
  supplier: string;
  key: string;
  description: string;
  productTypeDescription: string;
  purchaseOrderNumber: string;
  purchaseOrderPrice: number;
  purchaseOrderDate: Date;
  currency: string;
  exchangeRate: number;
  price: number;
  ratio: number;
  amountRequired: number;
  cost: number;
}
